import { render, staticRenderFns } from "./enter-points.vue?vue&type=template&id=459fecfe&scoped=true"
import script from "./enter-points.vue?vue&type=script&lang=js"
export * from "./enter-points.vue?vue&type=script&lang=js"
import style0 from "./enter-points.vue?vue&type=style&index=0&id=459fecfe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459fecfe",
  null
  
)

export default component.exports